import type { EnglishProficiencyStepProps } from './types'
import { useEnglishProficiencyActions } from './useEnglishProficiencyActions'
import { useEnglishProficiencyState } from './useEnglishProficiencyState'

type UseEnglishProficiencyFlowArgs = Pick<
  EnglishProficiencyStepProps,
  'enrollment' | 'onNext' | 'onPassed'
>

export function useEnglishProficiencyFlow({
  enrollment,
  onNext,
  onPassed
}: UseEnglishProficiencyFlowArgs) {
  const state = useEnglishProficiencyState({ enrollment })
  const {
    handleCloseTest,
    handleResultAction,
    handleStartTest,
    handleTestComplete,
    isStartingTest
  } = useEnglishProficiencyActions({
    onNext,
    onPassed,
    state
  })

  const resultButtonLabel = state.testPassed
    ? 'Continue Enrollment'
    : state.isRetryLockout
      ? 'Learn More About CDL'
      : 'Retake English Test'
  const resultButtonLoading = state.testPassed ? state.isContinuingAfterPass : isStartingTest

  return {
    assessmentId: state.assessmentId,
    continueError: state.continueError,
    defaultTest: state.defaultTest,
    effectiveTestResult: state.effectiveTestResult,
    handleCloseTest,
    handleResultAction,
    handleStartTest,
    handleTestComplete,
    initialAssessmentAnswers: state.initialAssessmentAnswers,
    isRetryLockout: state.isRetryLockout,
    isStartingTest,
    isTestModalOpen: state.isTestModalOpen,
    resultButtonLabel,
    resultButtonLoading,
    retryLockoutMessage: state.retryLockoutMessage,
    showResultScreen: state.showResultScreen,
    startTestError: state.startTestError,
    testPassed: state.testPassed
  }
}
